exports = module.exports = require("../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nhtml[data-v-7ba5bd90],\nbody[data-v-7ba5bd90] {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n.master-router[data-v-7ba5bd90] {\n  width: 100%;\n  height: 100%;\n}\n", "", {"version":3,"sources":["/root/.jenkins/workspace/frontend-base-pc/src/src/App.vue"],"names":[],"mappings":";AASA;;EAEA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;CACA;AACA;EACA,YAAA;EACA,aAAA;CACA","file":"App.vue","sourcesContent":["<template>\n  <router-view class=\"master-router\" id=\"master-router\"></router-view>\n</template>\n\n<script>\nexport default {};\n</script>\n\n<style scoped>\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n.master-router {\n  width: 100%;\n  height: 100%;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = NGlq
// module chunks = 27